
import "@sparta.accessible-banking.modules/services-resources-list-module/dist/styles.css"
import "@sparta.accessible-banking.modules/banking-by-mail-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import phoneLinkUtility from "@sparta.sales.utilities/phone-link-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"

import "@sparta.accessible-banking.modules/services-resources-list-module/dist/es6.js"
import "@sparta.accessible-banking.modules/banking-by-mail-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
phoneLinkUtility.run(arguments);
  console.log('after - execute boot functions')
})();
